import { useAtom } from 'jotai';

import { useSlideEditorContext } from '../../../context/SlideEditorContext';
import { editorUiAtom } from '../../../store/atoms/editorUiAtom';
import { slideAtom, type VariantKey } from '../../../store/atoms/slideAtom';

export function useSlideEditorBackground() {
  const ctx = useSlideEditorContext();
  const [uiState] = useAtom(editorUiAtom);
  const [slide] = useAtom(slideAtom);

  const variantKey: VariantKey = `${uiState.activeLanguage}-${uiState.activeDevice}`;
  const variant = slide.variants[variantKey];
  const backgroundColor = variant?.backgroundColor ?? '#141414';
  const backgroundImage = variant?.backgroundImage;
  const backgroundVideo = variant?.backgroundVideo;

  return {
    backgroundColor,
    backgroundImage,
    backgroundVideo,
    setBackground: ctx.setBackground,
    setBackgroundImage: ctx.setBackgroundImage,
    removeBackgroundImage: ctx.removeBackgroundImage,
  };
}
